import WTerrace1 from '../../Media/Produk/Water Terrace.webp'
import WTerrace2 from '../../Media/Produk/Water Terrace.webp'



const WTimages =[
    WTerrace1,WTerrace2
]

export default WTimages;